import { useEffect, useState } from 'react';

/**
 * Custom hook to get current URL without react-router-dom
 * Suitable for embedded widgets that need to work across different websites
 *
 * @returns current URL as a string, updates automatically when URL changes
 */
export const useCurrentUrl = () => {
  const [currentUrl, setCurrentUrl] = useState(() =>
    typeof window !== 'undefined' ? window.location.href : '',
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const updateUrl = () => {
      setCurrentUrl(window.location.href);
    };

    // Listen for URL changes (for SPAs that might change URL without page reload)
    window.addEventListener('popstate', updateUrl);

    // Also listen for pushstate/replacestate (for programmatic navigation)
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(window.history, args);
      updateUrl();
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(window.history, args);
      updateUrl();
    };

    return () => {
      window.removeEventListener('popstate', updateUrl);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  return currentUrl;
};
